import React, { useEffect, useState } from 'react';
import axios from 'axios';
import LoadingSpinner from '../../components/LoadingSpinner';

const PROJECT_TYPES = [
  { value: 'SAP Business One', label: 'SAP Business One' },
  { value: 'FEX', label: 'FEX' },
  { value: 'LEX', label: 'LEX' },
];

const AREAS = [
  { value: 'New Names', label: 'New Names' },
  { value: 'Mejora Continua', label: 'Mejora Continua' },
];

const FormProject = ({ onSubmit, onClose, project }) => {
  const [formData, setFormData] = useState({
    clientId: '',
    tipoProyecto: '',
    fechaInicio: '',
    fechaGoLive: '',
    fechaCierre: '',
    area: '',
    liderExxisId: '',
    liderClienteId: '',
  });

  const [users, setUsers] = useState([]);
  const [filteredUsersExxis, setFilteredUsersExxis] = useState([]);
  const [filteredUsersCliente, setFilteredUsersCliente] = useState([]);
   const [filteredUsersSbo, setFilteredUsersSbo] = useState([]);
   const [filteredUsersFex, setFilteredUsersFex] = useState([]);
  const [searchExxis, setSearchExxis] = useState('');
  const [searchCliente, setSearchCliente] = useState('');
  const [searchSbo, setSearchSbo] = useState('');
  const [searchFex, setSearchFex] = useState('');
  const [clients, setClients] = useState([]);
  const [searchClient, setSearchClient] = useState('');
  const [filteredClients, setFilteredClients] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchUsersAndClients = async () => {
      setIsLoading(true);
      try {
        const [usersResp, clientsResp] = await Promise.all([
          axios.get(
            `${((import.meta.env.VITE_ENV == 'development') ? import.meta.env.VITE_BACKEND_LOCAL : import.meta.env.VITE_BACKEND)}/users`,
            { withCredentials: true }
          ),
          axios.get(
            `${((import.meta.env.VITE_ENV == 'development') ? import.meta.env.VITE_BACKEND_LOCAL : import.meta.env.VITE_BACKEND)}/clients`,
            { withCredentials: true }
          ),
        ]);
        setUsers(usersResp.data);
        setFilteredUsersExxis(usersResp.data);
        setFilteredUsersCliente(usersResp.data);
        setFilteredUsersSbo(usersResp.data);
        setFilteredUsersFex(usersResp.data);
        setClients(clientsResp.data);
        setFilteredClients(clientsResp.data);
      } catch (error) {
        console.error('Error al cargar usuarios/clientes:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUsersAndClients();
  }, []);

  useEffect(() => {
    if (project) {
      setFormData((prev) => ({
        ...prev,
        clientId: project.client_id,
        tipoProyecto: project.project_type,
        fechaInicio: project.start_date ? project.start_date.split('T')[0] : '',
        fechaGoLive: project.go_live_date ? project.go_live_date.split('T')[0] : '',
        fechaCierre: project.end_date ? project.end_date.split('T')[0] : '',
        area: project.area,
        liderExxisId: project.lider_exxis_id || '',
        liderClienteId: project.lider_cliente_id || '',
      }));
      if (project.Client) {
        setSearchClient(`${project.Client.rut} - ${project.Client.business_name}`);
      }
    } else {
      setFormData({
        clientId: '',
        tipoProyecto: '',
        fechaInicio: '',
        fechaGoLive: '',
        fechaCierre: '',
        area: '',
        liderExxisId: '',
        liderClienteId: '',
      });
      setSearchClient('');
    }
  }, [project]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSearchExxis = (e) => {
    const value = e.target.value;
    setSearchExxis(value);
    const filtered = users.filter((u) =>
      u.name.toLowerCase().includes(value.toLowerCase()) ||
      u.email.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredUsersExxis(filtered);
  };

  const handleSearchCliente = (e) => {
    const value = e.target.value;
    setSearchCliente(value);
    const filtered = users.filter((u) =>
      u.name.toLowerCase().includes(value.toLowerCase()) ||
      u.email.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredUsersCliente(filtered);
  };

  const handleSelectExxis = (user) => {
    setFormData((prev) => ({
      ...prev,
      liderExxisId: user.id,
    }));
    setSearchExxis(user.name);
  };

  const handleSelectCliente = (user) => {
    setFormData((prev) => ({
      ...prev,
      liderClienteId: user.id,
    }));
    setSearchCliente(user.name);
  };

  const handleSearchSbo = (e) => {
    const value = e.target.value;
    setSearchSbo(value);
    const filtered = users.filter((u) =>
      u.name.toLowerCase().includes(value.toLowerCase()) ||
      u.email.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredUsersSbo(filtered);
  };

  const handleSearchFex = (e) => {
    const value = e.target.value;
    setSearchFex(value);
    const filtered = users.filter((u) =>
      u.name.toLowerCase().includes(value.toLowerCase()) ||
      u.email.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredUsersFex(filtered);
  };

  const handleSelectSbo = (user) => {
    setFormData((prev) => ({
      ...prev,
      consultorSboId: user.id,
    }));
    setSearchSbo(user.name);
  };

  const handleSelectFex = (user) => {
    setFormData((prev) => ({
      ...prev,
      consultorFexId: user.id,
    }));
    setSearchFex(user.name);
  };

  const handleSearchClient = (e) => {
    const value = e.target.value;
    setSearchClient(value);
    const filtered = clients.filter((c) =>
      c.business_name.toLowerCase().includes(value.toLowerCase()) ||
      c.rut.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredClients(filtered);
  };

  const handleSelectClient = (client) => {
    setFormData((prev) => ({
      ...prev,
      clientId: client.id,
    }));
    setSearchClient(`${client.rut} - ${client.business_name}`);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const {
      clientId,
      tipoProyecto,
      fechaInicio,
      area,
    } = formData;

    if (!clientId || !tipoProyecto || !fechaInicio || !area) {
      alert('Completa todos los campos obligatorios (*)');
      return;
    }

    if (onSubmit) {
      onSubmit(formData);
    } else {
      console.log('Nuevo proyecto:', formData);
      alert('Proyecto preparado (sin backend aún).');
    }

    if (onClose) onClose();
  };

  const today = new Date().toISOString().split('T')[0];

  return (
    <>
      {isLoading && <LoadingSpinner message="Cargando usuarios..." size="md" color="blue" fullScreen={false} />}
      <form onSubmit={handleSubmit} className="space-y-4 max-w-xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="md:col-span-2">
            <label className="block mb-1 text-sm font-medium text-gray-900 dark:text-white">
              Cliente*
            </label>
            <input
              type="text"
              value={searchClient}
              onChange={handleSearchClient}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
              placeholder="Buscar cliente por RUT o Razón social..."
            />
            {searchClient && (
              <div className="mt-1 max-h-40 overflow-y-auto border border-gray-200 rounded-md bg-white shadow-sm text-sm">
                {filteredClients.map((c) => (
                  <button
                    type="button"
                    key={c.id}
                    onClick={() => handleSelectClient(c)}
                    className="w-full text-left px-2 py-1 hover:bg-gray-100"
                  >
                    {c.rut} - {c.business_name}
                  </button>
                ))}
                {filteredClients.length === 0 && (
                  <div className="px-2 py-1 text-gray-400">Sin resultados</div>
                )}
              </div>
            )}
          </div>

          <div>
            <label className="block mb-1 text-sm font-medium text-gray-900 dark:text-white">
              Tipo de proyecto*
            </label>
            <select
              name="tipoProyecto"
              value={formData.tipoProyecto}
              onChange={handleChange}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
            >
              <option value="">Seleccione tipo</option>
              {PROJECT_TYPES.map((t) => (
                <option key={t.value} value={t.value}>{t.label}</option>
              ))}
            </select>
          </div>

          <div>
            <label className="block mb-1 text-sm font-medium text-gray-900 dark:text-white">
              Área*
            </label>
            <select
              name="area"
              value={formData.area}
              onChange={handleChange}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
            >
              <option value="">Seleccione área</option>
              {AREAS.map((a) => (
                <option key={a.value} value={a.value}>{a.label}</option>
              ))}
            </select>
          </div>

          <div>
            <label className="block mb-1 text-sm font-medium text-gray-900 dark:text-white">
              Fecha de inicio*
            </label>
            <input
              type="date"
              name="fechaInicio"
              value={formData.fechaInicio}
              onChange={handleChange}
              max={today}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
            />
          </div>

          <div>
            <label className="block mb-1 text-sm font-medium text-gray-900 dark:text-white">
              Fecha Go Live
            </label>
            <input
              type="date"
              name="fechaGoLive"
              value={formData.fechaGoLive}
              onChange={handleChange}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
            />
          </div>

          <div>
            <label className="block mb-1 text-sm font-medium text-gray-900 dark:text-white">
              Fecha de cierre
            </label>
            <input
              type="date"
              name="fechaCierre"
              value={formData.fechaCierre}
              onChange={handleChange}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
            />
          </div>
        </div>

        <div className="mt-6">
          <h3 className="text-md font-semibold text-gray-800 mb-2">
            Encargados
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-900 dark:text-white">
              Líder de proyecto Exxis
            </label>
            <input
              type="text"
              value={searchExxis}
              onChange={handleSearchExxis}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
              placeholder="Buscar usuario..."
            />
            {searchExxis && (
              <div className="mt-1 max-h-40 overflow-y-auto border border-gray-200 rounded-md bg-white shadow-sm text-sm">
                {filteredUsersExxis.map((u) => (
                  <button
                    type="button"
                    key={u.id}
                    onClick={() => handleSelectExxis(u)}
                    className="w-full text-left px-2 py-1 hover:bg-gray-100"
                  >
                    {u.name} <span className="text-xs text-gray-500">({u.email})</span>
                  </button>
                ))}
                {filteredUsersExxis.length === 0 && (
                  <div className="px-2 py-1 text-gray-400">Sin resultados</div>
                )}
              </div>
            )}
          </div>

          <div>
            <label className="block mb-1 text-sm font-medium text-gray-900 dark:text-white">
              Líder de proyecto Cliente
            </label>
            <input
              type="text"
              value={searchCliente}
              onChange={handleSearchCliente}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
              placeholder="Buscar usuario..."
            />
            {searchCliente && (
              <div className="mt-1 max-h-40 overflow-y-auto border border-gray-200 rounded-md bg-white shadow-sm text-sm">
                {filteredUsersCliente.map((u) => (
                  <button
                    type="button"
                    key={u.id}
                    onClick={() => handleSelectCliente(u)}
                    className="w-full text-left px-2 py-1 hover:bg-gray-100"
                  >
                    {u.name} <span className="text-xs text-gray-500">({u.email})</span>
                  </button>
                ))}
                {filteredUsersCliente.length === 0 && (
                  <div className="px-2 py-1 text-gray-400">Sin resultados</div>
                )}
              </div>
            )}
          </div>
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-900 dark:text-white">
              Consultor SBO
            </label>
            <input
              type="text"
              value={searchSbo}
              onChange={handleSearchSbo}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
              placeholder="Buscar usuario..."
            />
            {searchSbo && (
              <div className="mt-1 max-h-40 overflow-y-auto border border-gray-200 rounded-md bg-white shadow-sm text-sm">
                {filteredUsersSbo.map((u) => (
                  <button
                    type="button"
                    key={u.id}
                    onClick={() => handleSelectSbo(u)}
                    className="w-full text-left px-2 py-1 hover:bg-gray-100"
                  >
                    {u.name} <span className="text-xs text-gray-500">({u.email})</span>
                  </button>
                ))}
                {filteredUsersSbo.length === 0 && (
                  <div className="px-2 py-1 text-gray-400">Sin resultados</div>
                )}
              </div>
            )}
          </div>

          <div>
            <label className="block mb-1 text-sm font-medium text-gray-900 dark:text-white">
              Consultor FEX
            </label>
            <input
              type="text"
              value={searchFex}
              onChange={handleSearchFex}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
              placeholder="Buscar usuario..."
            />
            {searchFex && (
              <div className="mt-1 max-h-40 overflow-y-auto border border-gray-200 rounded-md bg-white shadow-sm text-sm">
                {filteredUsersFex.map((u) => (
                  <button
                    type="button"
                    key={u.id}
                    onClick={() => handleSelectFex(u)}
                    className="w-full text-left px-2 py-1 hover:bg-gray-100"
                  >
                    {u.name} <span className="text-xs text-gray-500">({u.email})</span>
                  </button>
                ))}
                {filteredUsersFex.length === 0 && (
                  <div className="px-2 py-1 text-gray-400">Sin resultados</div>
                )}
              </div>
            )}
          </div>
        </div>

        </div>

        <div className="flex justify-end gap-2 mt-4">
          <button
            type="button"
            onClick={onClose}
            className="bg-gray-200 text-gray-800 px-4 py-2 rounded-md"
          >
            Cancelar
          </button>
          <button
            type="submit"
            className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-md"
          >
            Guardar
          </button>
        </div>
      </form>
    </>
  );
};

export default FormProject;
